import React from 'react';
import { ArrowRight } from 'lucide-react';
import { insideCisco } from '../mock';

const InsideCisco = () => {
  return (
    <section className="bg-white py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0d274d] mb-12">Inside Cisco</h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {insideCisco.map((item, idx) => (
            <article key={idx} className="group cursor-pointer">
              <div className="aspect-[16/9] overflow-hidden mb-4">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <p className="text-xs font-semibold uppercase tracking-widest text-[#00bceb] mb-2">{item.tag}</p>
              <h3 className="text-lg font-semibold text-[#0d274d] mb-4 leading-snug group-hover:text-[#00bceb] transition-colors">
                {item.title}
              </h3>
              <a href="#" className="inline-flex items-center gap-2 text-sm text-[#0d274d] font-semibold border-b border-[#00bceb] pb-0.5 group-hover:text-[#00bceb]">
                {item.cta}
                <ArrowRight className="w-3.5 h-3.5" />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InsideCisco;
